import { render, staticRenderFns } from "./indexCategory.vue?vue&type=template&id=3b14be97&scoped=true&"
import script from "./indexCategory.vue?vue&type=script&lang=js&"
export * from "./indexCategory.vue?vue&type=script&lang=js&"
import style0 from "./indexCategory.vue?vue&type=style&index=0&id=3b14be97&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b14be97",
  null
  
)

export default component.exports